import { Button, MyTableComponent } from "components"
import { Box } from "theme-ui"
import { useTranslation } from "react-i18next"

export const EditMessageGroup = () => {
 // language translator
 const { t } = useTranslation("translation")

 const data = [
  {
   info1: "Schwere Fehler",
   info2: "1 Meldungen",
  },
  {
   info1: "Schwere Fehler",
   info2: "1 Meldungen",
  },
  {
   info1: "Schwere Fehler",
   info2: "1 Meldungen",
  },
  {
   info1: "Schwere Fehler",
   info2: "1 Meldungen",
  },
  {
   info1: "Schwere Fehler",
   info2: "1 Meldungen",
  },

  {
   info1: "Schwere Fehler",
   info2: "1 Meldungen",
  },
  {
   info1: "Schwere Fehler",
   info2: "1 Meldungen",
  },
  {
   info1: "Schwere Fehler",
   info2: "1 Meldungen",
  },
 ]

 const columns = [
  { Header: "Name", accessor: "info1" },
  { Header: t("investments"), accessor: "info2" },
  {
   Header: t("action"),
   Cell: () => (
    <div className="flex justify-end">
     <div className="mr-2">
      <Button size={"tableSmallSize"} color={"darkBrown"}>
       {" "}
       {t("edit")}
      </Button>
     </div>
     <div className="mr-2">
      <Button size={"tableSmallSize"} color={"pink"}>
       {" "}
       {t("delete")}
      </Button>
     </div>
    </div>
   ),
  },
 ]

 return (
  <div className="w-full lg:w-[96%] mx-auto relative h-screen  md:h-screen lg:h-full pt-5">
   <div className="flex lg:flex-row flex-col lg:justify-between lg:items-center mb-4">
    <h1 className="Jakarta-font font-bold text-xl">{t("editMessageGroups")}</h1>
    <div className="flex lg:flex-row flex-col lg:items-center">
     <div>
      <Button size={"doublexl"}>Forum Gera</Button>
     </div>
     <div className="lg:ml-2 py-2">
      <Button size={"doublexl"} color={"gray"}>
       Test Server
      </Button>
     </div>
    </div>
   </div>
   <Box bg="highlight" color="text-black">
    <div className="py-3 px-3">
     <Box bg="highlight" className="flex justify-between items-center py-4 px-2">
      <h1 className="Jakarta-font font-semibold text-lg">{t("messageGroups")}</h1>
      <div className="flex">
       <Button size={"xl"}>{t("new")}</Button>
      </div>
     </Box>
    </div>
   </Box>

   {/* ====== TableComponent ====== */}
   <MyTableComponent fullHeight={true} columns={columns} data={data} paginate={false} />
  </div>
 )
}
